'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { searchParamsData } from '@/lib/sbAPI'
import { getStoryblokApi } from '@/lib/storyblok'

import { PhnxSidenavtemplate } from './Sidenavtemplate'
import { SidenavtemplateProps } from './Sidenavtemplate'

interface SidenavsidenavtemplateBlokProps {
  blok: {
    title: SidenavtemplateProps['title']
    featured_asset: any
    herobanner: any
    description: SidenavtemplateProps['description']
    content: SbBlokData[]
    variant: SidenavtemplateProps['variant']
    nav: any
    TeamMembers: any
  } & SbBlokData
  rels: any
}

const Sidenavsidenavtemplate: FC<SidenavsidenavtemplateBlokProps> = ({ blok, rels }) => {
  const [nav, setNav] = useState()
  const [heroImage, setHeroImage] = useState<any>()
  const [teamMembers, setTeamMembers] = useState<any>()
  const [herobanner, setHerobanner] = useState<any>()

  useEffect(() => {
    if (blok.nav && blok.nav.length > 0) {
      const navArray = blok.nav.map((nav: any) => {
        let link = nav?.link?.cached_url
        // if ends with / remove
        if (link.endsWith('/')) {
          link = link.slice(0, -1)
        }
        let currentPath = window.location.pathname
        // remove leading /
        if (currentPath.startsWith('/')) {
          currentPath = currentPath.slice(1)
        }
        return {
          title: nav.title,
          link: nav?.link?.cached_url,
          target: nav?.link?.target,
          currentPath: link === currentPath,
        }
      })
      setNav(navArray)
    } else {
      // attempt to get the nav from the content parent
      let currentPath = window.location.pathname
      // remove leading /
      if (currentPath.startsWith('/')) {
        currentPath = currentPath.slice(1)
      }
      // get the fiirst part of the path
      let pathArray = currentPath.split('/')
      let path = pathArray[0]

      let sbParams = { ...searchParamsData }
      const fetchMenu = async () => {
        const storyblokApi = getStoryblokApi()
        let { data } = await storyblokApi.get(`cdn/stories/${path}`, sbParams)

        // if data.stories we need to check if there is a nav to get
        if (data?.story?.content?.nav && data.story.content.nav.length > 0) {
          const navArray = data.story.content.nav.map((nav: any) => {
            let link = nav?.link?.cached_url
            // if ends with / remove
            if (link.endsWith('/')) {
              link = link.slice(0, -1)
            }
            return {
              title: nav.title,
              link: nav?.link?.cached_url,
              target: nav?.link?.target,
              currentPath: link === currentPath,
            }
          })
          setNav(navArray)
        }
      }

      fetchMenu()
    }
  }, [blok.nav])

  useEffect(() => {
    if (blok.featured_asset?.filename) {
      setHeroImage({
        src: blok.featured_asset.filename,
        alt: blok.featured_asset.alt,
        focus: blok.featured_asset.focus,
      })
    } else {
      // attempt to get the nav from the content parent
      let currentPath = window.location.pathname
      // remove leading /
      if (currentPath.startsWith('/')) {
        currentPath = currentPath.slice(1)
      }
      // get the fiirst part of the path
      let pathArray = currentPath.split('/')
      let path = pathArray[0]

      let sbParams = { ...searchParamsData }
      const fetchHero = async () => {
        const storyblokApi = getStoryblokApi()
        let { data } = await storyblokApi.get(`cdn/stories/${path}`, sbParams)
        // if data.stories we need to check if there is a nav to get
        if (data?.story?.content?.featured_asset?.filename) {
          setHeroImage({
            src: data.story.content.featured_asset.filename,
            alt: data.story.content.featured_asset.alt,
            focus: data.story.content.featured_asset.focus,
          })
        }
      }
      fetchHero()
    }
  }, [blok.featured_asset])

  useEffect(() => {
    if (blok.TeamMembers && blok.TeamMembers.length > 0) {
      const processedMembers = blok.TeamMembers.map((member: any) => {
        // If member is a UUID, find it in rels
        if (typeof member === 'string' && rels) {
          const rel = rels.find((rel: any) => rel.uuid === member)
          return rel
        }
        // If member is already a full object, use it directly
        return member
      }).filter(Boolean) // Remove any undefined/null values

      setTeamMembers(processedMembers)
    }
  }, [blok.TeamMembers, rels])

  useEffect(() => {
    if (blok.herobanner && blok.herobanner.length > 0) {
      const herobannerData = blok.herobanner[0] // Get the first herobanner block

      // Only set herobanner if there's actually a video_id or asset
      if (herobannerData.video_id || herobannerData.asset) {
        setHerobanner({
          video_id: herobannerData.video_id,
          asset: herobannerData.asset
            ? {
                src: herobannerData.asset.filename,
                alt: herobannerData.asset.alt,
                focus: herobannerData.asset.focus,
              }
            : undefined,
        })
      } else {
        setHerobanner(undefined)
      }
    } else {
      setHerobanner(undefined)
    }
  }, [blok.herobanner])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxSidenavtemplate
        title={blok.title}
        description={blok.description}
        image={{ src: heroImage?.src, alt: heroImage?.alt, focus: heroImage?.focus }}
        herobanner={herobanner}
        content={
          blok.content &&
          blok.content.map((child) => <StoryblokServerComponent blok={child} key={child._uid} />)
        }
        nav={nav}
        variant={blok.variant}
        teamMembers={teamMembers}
      />
    </div>
  )
}

export default Sidenavsidenavtemplate
